import React from 'react';
import { selectIsLoggedIn } from 'store/Sesion/selectors';
import { selectLocation } from 'store/Router/selectors';
import { useSelector } from 'react-redux';
import Searcher from 'Common/Components/Searcher';
import WorkspaceSelector from './WorkspaceMenuSelector';
import ThemeToggle from './ThemeToggle';
import ProcessingQueueButton from './ProcessingQueueButton';
import {
  Header, Separator, LeftZone, CenterZone, RightZone
} from './styled';
import VulnsCounter from './VulnsCounter';
import AssetSelector from './AssetSelector';
import Title from './Title';
import HomeButton from './HomeButton';
import HostModalCreate from '../HostModalCreate';

const NavMenuContext = () => {
  const loggedIn = useSelector((state) => selectIsLoggedIn(state));
  const location = useSelector((state) => selectLocation(state));
  const isInsideWs = location.pathname.startsWith('/feed') ||
   location.pathname.startsWith('/host/') ||
   location.pathname.startsWith('/manage') ||
   location.pathname.startsWith('/service/') ||
   location.pathname.startsWith('/credentials');
  const customPadding = location.pathname === '/automation/agents';

  return loggedIn && (
    <Header customPadding={ customPadding }>
      <LeftZone>
        <Title />
        { isInsideWs &&
          <>
            <HomeButton />
            <Separator />
            <WorkspaceSelector />
          </>
        }
        <AssetSelector />
        <VulnsCounter />
      </LeftZone>
      <CenterZone>
        <Searcher />
      </CenterZone>
      <HostModalCreate />
      <RightZone>
        <ThemeToggle />
        <ProcessingQueueButton />
      </RightZone>
    </Header>
  );
};

export default NavMenuContext;
